
import Vue from 'vue';
import { BInputGroup, BFormInput, BFormInvalidFeedback } from 'bootstrap-vue';
import { formatValidationInputStyle, rangeValidation } from '../../utilities/input-formatting';
import { debounce } from '../../utilities/debounce';

export default Vue.extend({
	components: {
		BInputGroup,
		BFormInput,
		BFormInvalidFeedback
	},
	inheritAttrs: false,
	props: {
		state: {
			type: Boolean,
			required: false,
			default: null
		},
		inputGroupAppend: {
			type: String,
			required: false,
			default: null
		},
		inputGroupPrepend: {
			type: String,
			required: false,
			default: null
		},
		value: {
			type: String,
			required: false,
			default: ''
		},
		showIcon: {
			// validation input icon
			type: Boolean,
			required: false,
			default: false
		},
		hideValidationText: {
			type: Boolean,
			required: false,
			default: false
		},
		maxLength: {
			type: Number,
			required: false,
			default: null
		},
		minLength: {
			type: Number,
			required: false,
			default: null
		},
		showValidation: {
			// shows green/red validation border and validation text
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			displayValue: '' as string,
			validationStatus: null as any,
			SEARCH_DEBOUNCE: 1000 as number
		};
	},
	computed: {
		dynamicInputStyles(): string {
			return formatValidationInputStyle(this.showIcon, this.showValidation, this.displayValue, this.minLength);
		},
		input: {
			get(): HTMLInputElement {
				return (this as any).$refs.input as HTMLInputElement;
			}
		}
	},
	watch: {
		value: {
			handler(val) {
				if (val !== null && val !== '') {
					this.displayValue = val;
				} else {
					this.displayValue = '';
				}
			},
			immediate: true
		},
		displayValue: function() {
			debounce(() => {
				this.isInRange();
				this.emitValidation(this.validationStatus);
			}, this.SEARCH_DEBOUNCE)();
		}
	},
	methods: {
		focus(): void {
			this.input.focus();
		},
		selected(): void {
			this.input.select();
		},
		emitValidation(valid: boolean): void {
			this.$emit('valid', valid);
		},
		isInRange(): any {
			if (this.value !== null && this.value !== '') {
				this.validationStatus = rangeValidation(null, null, this.minLength || 0, this.displayValue, this.emitValidation, this.maxLength);
			}
		}
	}
});
